import * as React from "react";
import calculateDimensions from "@insite/shell/Components/Icons/CalculateDimensions";

const Redo: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#4A4A4A",
    className,
}) => {
    const { calculatedWidth, calculatedHeight } = calculateDimensions(width, height, 19, 20);
    return (
        <svg
            focusable="false"
            className={className}
            viewBox="0 0 19 20"
            width={calculatedWidth}
            height={calculatedHeight}
        >
            <g stroke={color1} strokeWidth="2" fill="none" strokeLinecap="round">
                <path d="M12.784 6.195l5.019.027-.025-5.021" />
                <path d="M15.95 15.95c-3.35 3.351-8.86 3.27-12.31-.18C.191 12.323.11 6.81 3.46 3.462c3.35-3.35 8.863-3.27 12.31.18a8.987 8.987 0 011.81 2.576" />
            </g>
        </svg>
    );
};

export const RedoSrc: React.FC<{ disabled: boolean }> = ({ disabled }) => {
    const fillValue = disabled ? "#9E9E9E" : "#0037FF";

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
            <path
                d="M9.95312 1.03125C12.4531 1.03125 14.7031 2.3125 15.9844 4.4375V1.5C15.9844 1.25 16.2031 1 16.4844 1C16.7344 1 16.9844 1.25 16.9844 1.5V5.5C16.9844 5.78125 16.7344 6 16.4844 6H12.4844C12.2031 6 11.9844 5.78125 11.9844 5.5C11.9844 5.25 12.2031 5 12.4844 5H15.1406C14.0781 3.15625 12.1094 2 9.98438 2C6.67188 2 3.98438 4.71875 3.98438 8C3.98438 11.3125 6.67188 14 9.98438 14C11.8281 14 13.5469 13.1875 14.7031 11.7188C14.8594 11.5 15.1719 11.4375 15.3906 11.625C15.6094 11.7812 15.6406 12.0938 15.4844 12.3125C14.1406 14.0312 12.1406 15 9.95312 15C6.10938 15 2.98438 11.875 2.98438 8C2.98438 4.15625 6.10938 1.03125 9.95312 1.03125Z"
                fill={fillValue}
            />
        </svg>
    );
};

export default React.memo(Redo);
